import { render, staticRenderFns } from "./ApprovalLevel2.vue?vue&type=template&id=3ed8b7db"
import script from "./ApprovalLevel2.vue?vue&type=script&lang=js"
export * from "./ApprovalLevel2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports